import { TIERS } from "/constants/pricing";
import isEmpty from "lodash/isEmpty";
import { isInClusterTest } from "./clusterized-pricing-page-service";
import { MIN_BUCKET_SIZE_TO_RECOMMEND_PRO, MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE } from "segments/desktop/pricing/constants";
export const getMostPopularTierByBucketSize = (userCount, plans, unitOfMeasure)=>{
    const realUserCount = parseInt(userCount);
    const minBucketSizeToRecommendEnterprise = MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE[unitOfMeasure];
    if (realUserCount >= minBucketSizeToRecommendEnterprise) {
        return TIERS.ENTERPRISE;
    }
    if (!plans.find(({ tier })=>tier === TIERS.STANDARD)) {
        return TIERS.PRO;
    }
    const minBucketSizeToRecommendPro = MIN_BUCKET_SIZE_TO_RECOMMEND_PRO[unitOfMeasure];
    return realUserCount >= minBucketSizeToRecommendPro ? TIERS.PRO : TIERS.STANDARD;
};
const getClusterMostPopularConfig = (clusterConfig, abTests, cookies, forcePricing)=>{
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    const mostPopular = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.most_popular;
    if (!isEmpty(mostPopular) && isInClusterTest(clusterConfig, {
        abTests,
        cookies,
        forcePricing
    })) {
        return mostPopular;
    }
    return {};
};
export const getMostPopularTierAndText = (userCount, plans, clusterConfig, abTests, cookies, forcePricing, unitOfMeasure)=>{
    const clusterMostPopularConfig = getClusterMostPopularConfig(clusterConfig, abTests, cookies, forcePricing);
    const { forced_tier: forcedTier, text_for_forced_tier: textForForcedTier, minimum_users_count: minimumUsersCount } = clusterMostPopularConfig;
    const mostPopularTier = forcedTier || getMostPopularTierByBucketSize(userCount, plans, unitOfMeasure);
    return {
        tier: mostPopularTier,
        text: forcedTier && textForForcedTier ? textForForcedTier : "pricingPage.mostPopular",
        minimumUsersCount
    };
};
